export const ADD_BOOKING  = "booking/addBooking";

export const REMOVE_BOOKING  = "booking/removeBooking";